import api from './api';
import { Material } from '/types/jobTemplateTypes';

const findMaterials = (query: string) =>
    api.getSecure('product/search?query=' + query);

const getArticles = (
    articles: string[],
    token?: string
): Promise<{ data: Material[] }> => {
    const res = api.post('product/articles', { articles }, token);

    if (res.error) throw res;
    return res;
};

const erpApi = {
    findMaterials,
    getArticles,
};

export default erpApi;
